import React from 'react'
import {
  CircularProgress,
  Pagination,
  PaginationItem,
  Paper,
  Stack,
  TablePagination as MuiTablePagination,
  tablePaginationClasses,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'
import theme from 'theme'

const StyledTablePagination = styled(MuiTablePagination)(({ theme }) => ({
  [`& .${tablePaginationClasses.select}`]: {
    border: `1px solid ${theme.custom.inputBorder}`,
    borderRadius: theme.shape.borderRadius,
    '&:hover, &:focus': {
      borderColor: theme.palette.text.primary,
      borderRadius: theme.shape.borderRadius,
    },
  },
}))

export default function TablePagination({
  isFetching = false,
  total,
  rowsPerPage = 10,
  rowsPerPageOptions = [10, 25, 50, 100],
  page = 0,
  handleChangePage,
  handleChangeRowsPerPage,
}) {
  const { t } = useTranslation()

  const handleChangePageStartingFromOne = (event, newPage) => {
    handleChangePage(event, newPage - 1)
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className="content-container"
      component={Paper}
      p={0}
      mb={2.5}
      sx={{ position: 'fixed', bottom: 0, zIndex: 4 }}
    >
      <Pagination
        count={Math.ceil(total / rowsPerPage)}
        shape="rounded"
        page={page + 1}
        color="primary"
        renderItem={(itemProps) => (
          <PaginationItem
            {...itemProps}
            variant={itemProps.type !== 'page' ? 'outlined' : itemProps.variant}
          />
        )}
        onChange={handleChangePageStartingFromOne}
        sx={{ paddingLeft: (theme) => theme.spacing(2) }}
      />
      {isFetching && <CircularProgress size={theme.spacing(4)} />}

      <StyledTablePagination
        SelectProps={{
          id: 'stable-select-id',
          labelId: 'stable-select-label-id',
        }}
        labelRowsPerPage={t('common.table.rowsPerPage')}
        labelDisplayedRows={() => null}
        nextIconButtonProps={{ sx: { display: 'none' } }}
        backIconButtonProps={{ sx: { display: 'none' } }}
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={total}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Stack>
  )
}

TablePagination.propTypes = {
  isFetching: T.bool.isRequired,
  total: T.number.isRequired,
  rowsPerPage: T.number,
  rowsPerPageOptions: T.array,
  page: T.number,
  handleChangePage: T.func,
  handleChangeRowsPerPage: T.func,
}
